.track {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
}

.track .active {
  background-color: var(--gray);
  cursor: pointer;
}

.track .inactive {
  background-color: var(--gray-xl);
  cursor: pointer;
}

.thumb {
  width: 14px;
  height: 14px;
  border: none;
  background-color: var(--black-l);
}